import Icon from '@components/CustomIcon';
import { ComponentProps } from 'react';

type TextSegment = string | { strong: string };

export interface IntroItem {
  icon: ComponentProps<typeof Icon>['name'];
  text: TextSegment[];
}

export const features: IntroItem[] = [
  { icon: 'computerscreen', text: ['Webinaires personnalisés'] },
  { icon: 'hand', text: ['Rendez-vous avec un mentor/coachs'] },
  { icon: 'graduationcap', text: ['Formation certifiante / diplomante'] },
  { icon: 'computergraph', text: ['Des vidéos 100 % exclusives'] },
];

export const adviser: IntroItem = {
  icon: 'headset',
  text: [
    { strong: 'Un conseiller expert' },
    ' vous contactera rapidement pour faire le point sur votre projet, définir vos objectifs et choisir la formation la plus adaptée.',
  ],
};

export const nextSteps: IntroItem[] = [
  {
    icon: 'lightbulb',
    text: [
      {
        strong: 'Voici ce qui vous attend après avoir rempli notre formulaire:',
      },
    ],
  },
  adviser,
  {
    icon: 'calendar',
    text: [
      'Ensemble, vous découvrirez ',
      { strong: 'les solutions de financement disponibles' },
      ' et fixerez votre ',
      { strong: 'date de début' },
      '.',
    ],
  },
  {
    icon: 'arrow-right',
    text: [
      { strong: 'Un appel, un accompagnement, un nouvel avenir' },
      ': tout commence ici !',
    ],
  },
];
